var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "page"
  }, [_vm.getConfig('form_title') ? _c('div', {
    staticClass: "page__title"
  }, [_vm._v(" " + _vm._s(_vm.getConfig("form_title")) + " ")]) : _vm._e(), _vm.getConfig('form_desc') ? _c('div', {
    staticClass: "page__desc"
  }, [_vm._v(" " + _vm._s(_vm.getConfig("form_desc")) + " ")]) : _vm._e(), _vm.getConfig('content') ? _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.getConfig('content'))
    }
  }) : _vm._e(), _vm.getConfig('content_url') ? _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.getConfig('content_url'))
    }
  }) : _vm._e(), _vm._l(_vm.contentImages, function (image) {
    return _c('img', {
      key: image.order,
      staticClass: "w-100",
      attrs: {
        "src": image.image_url
      }
    });
  }), _vm.objects.length ? [_c('ul', {
    staticClass: "s-p-3"
  }, _vm._l(_vm.objects, function (object, i) {
    return _c('li', {
      key: i,
      staticClass: "mb-3"
    }, [_c('Item', {
      attrs: {
        "object": object,
        "field-setting": _vm.getConfig('field_setting')
      }
    })], 1);
  }), 0), _c('Pagination', {
    attrs: {
      "current": _vm.currentPage,
      "last": _vm.lastPage
    }
  })] : _c('div', {
    staticClass: "s-pt-40 s-text-center"
  }, [_c('img', {
    staticClass: "s-mb-3",
    attrs: {
      "src": require("@/assets/images/liff/empty.svg")
    }
  }), _c('p', {
    staticClass: "s-text-gray"
  }, [_vm._v("沒有內容")]), _c('p', {
    staticClass: "s-text-gray"
  }, [_vm._v("小幫手每 3 分鐘會更新一次狀態唷")])])], 2), _vm.getConfig('button_text') ? _c('div', {
    staticClass: "page__button s-space-y-4"
  }, [_c('MemberButton', {
    attrs: {
      "button-text": _vm.getConfig('button_text'),
      "button-url": _vm.getConfig('button_url'),
      "type": _vm.getConfig('button_action')
    }
  })], 1) : _vm._e()]);
}
var staticRenderFns = []

export { render, staticRenderFns }